import { createStoreWithProducer } from '@xstate/store';
import { produce } from 'immer';

export type TranscriptStoreContext = {
  interimTranscript?: string;
  isTranscriptionDegraded?: boolean;
};

const defaultContext: TranscriptStoreContext = {
  interimTranscript: undefined,
  isTranscriptionDegraded: undefined,
};

export const transcriptStore = createStoreWithProducer(
  produce,
  defaultContext,
  {
    setInterimTranscript: (
      context,
      event: { transcript: string | undefined },
    ) => {
      context.interimTranscript = event.transcript;
    },
    clearInterimTranscript: (context) => {
      context.interimTranscript = undefined;
    },
    setTranscriptionDegraded: (context, event: { isDegraded: boolean }) => {
      context.isTranscriptionDegraded = event.isDegraded;
    },
    clearTranscriptionDegraded: (context) => {
      context.isTranscriptionDegraded = undefined;
    },
  },
);
